export const PDP_URL = 'pdp'
export const PDP_DETAIL_URL = 'pdp-detail'

export const PDP_TRANSACTION_PATH = `/project/:id/${PDP_URL}`
export const PDP_DETAIL_TRANSACTION_PATH = `/project/:id/${PDP_URL}/:product`
